import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Logo } from "@/components/Logo";

const DURATION = 5000;
const TIPS = ["Oyun serverinə qoşulur...", "Qrafika yüklənir...", "Təhlükəsiz bağlantı yoxlanılır...", "Masa hazırlanır..."];

export const GameLoader = ({ game, onDone }) => {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    const start = Date.now();
    const iv = setInterval(() => {
      const p = Math.min(100, ((Date.now() - start) / DURATION) * 100);
      setPct(p);
      if (p >= 100) { clearInterval(iv); onDone(); }
    }, 50);
    return () => clearInterval(iv);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="relative max-w-4xl mx-auto rounded-3xl overflow-hidden border border-[#D4AF37]/40 aspect-[4/5] sm:aspect-[16/9]" data-testid="game-loader">
      <motion.img src={game.image} alt="" initial={{ scale: 1.25 }} animate={{ scale: 1 }} transition={{ duration: 5, ease: "easeOut" }} className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-black/20" />
      <div className="absolute inset-0 flex flex-col items-center justify-end p-6 sm:p-12 gap-5">
        <Logo />
        <motion.h2 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="font-display font-black text-3xl sm:text-6xl tracking-tighter gold-text text-center">{game.name}</motion.h2>
        <div className="w-full max-w-md">
          <div className="h-2 rounded-full bg-white/10 overflow-hidden">
            <div className="h-full rounded-full btn-gold" style={{ width: `${pct}%` }} data-testid="loader-progress" />
          </div>
          <div className="flex justify-between text-xs text-zinc-400 mt-2">
            <span>{TIPS[Math.min(TIPS.length - 1, Math.floor(pct / 25))]}</span>
            <span className="font-display" data-testid="loader-percent">{Math.floor(pct)}%</span>
          </div>
        </div>
      </div>
    </div>
  );
};
